import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SUGGESTED_VIDEOS = [
  { id: 'bnzNyYjug9g', title: 'Marble Run Race — Handmade Wooden Course ASMR', channel: 'Marble ASMR Healing' },
  { id: 'eYWTCHacsHY', title: '7 Satisfying 3D-Printed Fidget Toys (ASMR)', channel: 'Printsculptors' },
  { id: '9XvzO5ncmUM', title: 'ASMR International Soap Haul — Opening Sounds', channel: 'ASMR Sound Queen' },
  { id: 'Xdrbp6xb8Eo', title: 'ASMR Mini Vending Machine', channel: 'LetsOpenStuff' },
  { id: 'NZiM0_4-j1k', title: 'Satisfying Slime ASMR — Relaxing Slime Videos', channel: 'CSM Relaxing' },
  { id: 'TbIDEHUiPPw', title: 'ASMR Bricklaying', channel: 'FD Brickwork' },
];

const NF_STYLES = `
  @keyframes nf-ripple { 0% { transform: scale(0.35); opacity: 0.55; } 100% { transform: scale(1.7); opacity: 0; } }
  @keyframes nf-bob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
  @keyframes nf-drift { 0% { transform: translateY(0) rotate(0deg); opacity: 0; } 15% { opacity: 0.9; } 100% { transform: translateY(-52px) rotate(12deg); opacity: 0; } }
  .nf-hero { padding: 56px 16px 48px; text-align: center; position: relative; overflow: hidden; }
  .nf-hero__glow { position: absolute; inset: 0; background: radial-gradient(circle at 50% 20%, var(--primary-light, #e0feff) 0%, rgba(224,254,255,0) 55%); pointer-events: none; }
  .nf-hero__scene { position: relative; width: 240px; height: 240px; margin: 0 auto 34px; display: flex; align-items: center; justify-content: center; }
  .nf-hero__ring { position: absolute; width: 220px; height: 220px; border-radius: 50%; border: 2px solid var(--primary-color, #6cf2f4); animation: nf-ripple 3.6s ease-out infinite; }
  .nf-hero__ring--2 { animation-delay: 1.2s; }
  .nf-hero__ring--3 { animation-delay: 2.4s; }
  .nf-hero__sleeper { position: relative; animation: nf-bob 5s ease-in-out infinite; }
  .nf-hero__sleeper img { height: 170px; width: auto; }
  .nf-hero__z { position: absolute; top: -8px; right: -34px; font-family: 'Qahiri', cursive; animation: nf-drift 3.4s ease-in-out infinite; }
  .nf-hero__z--1 { font-size: 30px; color: var(--primary-dark, #00c8cc); }
  .nf-hero__z--2 { font-size: 22px; color: var(--secondary-color, #7e57c2); animation-delay: 1.1s; }
  .nf-hero__z--3 { font-size: 16px; color: var(--primary-dark, #00c8cc); animation-delay: 2.2s; }
  .nf-hero__badge { position: relative; display: inline-flex; align-items: center; gap: 8px; background: var(--card-bg, #e6f9fa); color: #00807f; font-weight: 700; font-size: 13px; letter-spacing: 0.12em; text-transform: uppercase; padding: 8px 18px; border-radius: 999px; margin-bottom: 20px; }
  .nf-hero__title { position: relative; font-weight: 900; font-size: 58px; line-height: 1.05; margin: 0 0 18px; color: var(--text-color, #263238); }
  .nf-hero__lede { position: relative; font-size: 20px; line-height: 1.6; color: #5a6a6b; max-width: 600px; margin: 0 auto 34px; }
  .nf-hero__ctas { position: relative; display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
  .nf-btn { display: inline-flex; align-items: center; gap: 9px; font-weight: 700; font-size: 17px; border-radius: 999px; text-decoration: none; }
  .nf-btn--primary { background: var(--primary-dark, #00c8cc); color: #fff; padding: 15px 34px; box-shadow: 0 8px 20px rgba(0,200,204,0.35); }
  .nf-btn--primary:hover { background: var(--secondary-color, #7e57c2); color: #fff; }
  .nf-btn--ghost { background: #fff; color: #00807f; padding: 15px 32px; border: 1.5px solid var(--primary-color, #6cf2f4); }
  .nf-picks { max-width: 1240px; margin: 0 auto; padding: 8px 0 20px; }
  .nf-picks__title { font-weight: 900; font-size: 26px; margin: 0 0 4px; color: var(--text-color, #263238); }
  .nf-picks__sub { margin: 0 0 24px; color: #5a6a6b; font-size: 15px; }
  .nf-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
  .nf-card { display: flex; flex-direction: column; background: var(--card-bg, #e6f9fa); border: 1px solid rgba(0,0,0,0.06); border-radius: 14px; overflow: hidden; color: var(--text-color, #263238); transition: transform .2s, box-shadow .2s; text-decoration: none; }
  .nf-card:hover { transform: translateY(-5px); box-shadow: 0 12px 26px rgba(0,0,0,0.12); color: var(--text-color, #263238); }
  .nf-card__thumb { position: relative; padding-top: 56.25%; background: #000; }
  .nf-card__thumb img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
  .nf-card__play { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); color: #fff; font-size: 46px; text-shadow: 0 0 12px rgba(0,0,0,0.5); }
  .nf-card__body { padding: 13px 15px 15px; }
  .nf-card__title { font-weight: 600; font-size: 15px; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .nf-card__channel { color: var(--secondary-color, #7e57c2); font-size: 13.5px; margin-top: 7px; }
  .nf-debug { margin-top: 38px; border-top: 1px dashed rgba(0,0,0,0.12); padding-top: 20px; }
  .nf-debug__toggle { display: inline-flex; align-items: center; gap: 8px; background: none; border: none; cursor: pointer; color: #5a6a6b; font-family: 'Roboto', system-ui, sans-serif; font-weight: 600; font-size: 14px; padding: 0; }
  .nf-debug__caret { font-size: 11px; }
  .nf-debug__panel { margin-top: 14px; background: #eef2f2; border-radius: 10px; padding: 18px 20px; font-family: ui-monospace, 'SF Mono', Menlo, monospace; font-size: 13px; line-height: 1.9; color: #37474f; overflow-x: auto; max-width: 640px; }
  .nf-debug__panel span { color: #00807f; font-weight: 700; }
  @media (max-width: 900px) { .nf-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 620px) {
    .nf-grid { grid-template-columns: 1fr; }
    .nf-hero { padding: 40px 8px 36px; }
    .nf-hero__title { font-size: 38px; }
  }
  @media (prefers-reduced-motion: reduce) {
    .nf-hero__ring, .nf-hero__sleeper, .nf-hero__z { animation: none; }
  }
`;

const NotFound = () => {
  const [showDebug, setShowDebug] = useState(false);

  return (
    <div className="nf-page">
      <style>{NF_STYLES}</style>

      <section className="nf-hero">
        <div className="nf-hero__glow" />
        <div className="nf-hero__scene">
          <div className="nf-hero__ring" />
          <div className="nf-hero__ring nf-hero__ring--2" />
          <div className="nf-hero__ring nf-hero__ring--3" />
          <div className="nf-hero__sleeper">
            <span className="nf-hero__z nf-hero__z--1">z</span>
            <span className="nf-hero__z nf-hero__z--2">z</span>
            <span className="nf-hero__z nf-hero__z--3">z</span>
            <img src="/img/logo-blue-transparent-672x773.png" alt="Sleeping ASMR guru" />
          </div>
        </div>
        <div className="nf-hero__badge">Error 404 · silence detected</div>
        <h1 className="nf-hero__title">Shhh… this page is fast asleep.</h1>
        <p className="nf-hero__lede">
          The link you followed drifted off into the quiet. There’s nothing to hear here — but
          there are plenty of tingles waiting just around the corner.
        </p>
        <div className="nf-hero__ctas">
          <Link to="/" className="nf-btn nf-btn--primary">Take me home</Link>
          <Link to="/" className="nf-btn nf-btn--ghost">Browse all videos</Link>
        </div>
      </section>

      <section className="nf-picks">
        <h2 className="nf-picks__title">Whisper-worthy picks while you’re here</h2>
        <p className="nf-picks__sub">Hand-plucked calm from the directory.</p>
        <div className="nf-grid">
          {SUGGESTED_VIDEOS.map((video) => (
            <a
              key={video.id}
              className="nf-card"
              href={`https://www.youtube.com/watch?v=${video.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="nf-card__thumb">
                <img src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`} alt={video.title} loading="lazy" />
                <span className="nf-card__play">▸</span>
              </div>
              <div className="nf-card__body">
                <div className="nf-card__title">{video.title}</div>
                <div className="nf-card__channel">{video.channel}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="nf-debug">
          <button
            type="button"
            className="nf-debug__toggle"
            aria-expanded={showDebug}
            onClick={() => setShowDebug((open) => !open)}
          >
            <span className="nf-debug__caret">{showDebug ? '▼' : '▶'}</span>
            {showDebug ? 'Hide debug details' : 'Show debug details'}
          </button>
          {showDebug && (
            <div className="nf-debug__panel">
              <div><span>Requested URL:</span> {window.location.pathname + window.location.search}</div>
              <div><span>Referrer:</span> {document.referrer || '(none)'}</div>
              <div><span>Host:</span> {window.location.host}</div>
              <div><span>User Agent:</span> {navigator.userAgent}</div>
              <div><span>Redirect Status:</span> 404</div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default NotFound;
